import { AppEventName } from './enums';

export const FRIENDS_INVITATION_EVENTS = [
	AppEventName.AppFriendsInvitation,
	AppEventName.MailruAppEventsFriendsInvitation,
];

export const FRIENDS_PAGE_SIZE = 100;
